/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import ActionRequiredMenuTile from "../../../common/components/ActionRequiredMenuTile/ActionRequiredMenuTile";

interface propsType {
  isLoading?: boolean;
  trans?: any;
  i18n?: any;
  all_menus?: any;
  callBackArValue?: any;
}

const ActionRequiredMenusPresenter: React.FC<propsType> = ({
  all_menus,
  callBackArValue,
}) => {

  const handleSelectedMenu = (menu: any, eventName: any) => {
    callBackArValue({ menu, eventName });
  };

  return (
    <div>
      <CustomEditCard
        card_title={""}
        card_height="65vh"
        maxHeightForScroll={"62vh"}
        showEditButton={false}
      >
        {all_menus?.length > 0 &&
          all_menus?.map((data: any) => {
            return (
              <div key={data?.id}>
                <ActionRequiredMenuTile
                  name={data?.name}
                  onClick={() => {
                    handleSelectedMenu(data?.name, data?.eventName);
                  }}
                />
              </div>
            );
          })}
      </CustomEditCard>
    </div>
  );
};

export default ActionRequiredMenusPresenter;
